import { render, staticRenderFns } from "./CompetenceHardSkills.vue?vue&type=template&id=5f87314e&scoped=true"
import script from "./CompetenceHardSkills.vue?vue&type=script&lang=js"
export * from "./CompetenceHardSkills.vue?vue&type=script&lang=js"
import style0 from "./CompetenceHardSkills.vue?vue&type=style&index=0&id=5f87314e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f87314e",
  null
  
)

export default component.exports